import { render, staticRenderFns } from "./BlankDashboard.vue?vue&type=template&id=28a70342&"
import script from "./BlankDashboard.vue?vue&type=script&lang=js&"
export * from "./BlankDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports